"use client";

export type User = {
  id: string;
  firstName: string | null;
  color: string;
};

const USER_COLORS = [
  "#fb7185",
  "#fdba74",
  "#d9f99d",
  "#a7f3d0",
  "#a5f3fc",
  "#a5b4fc",
  "#f0abfc",
  "#fda58d",
  "#f2cc8f",
  "#9ae6b4",
];

const getRandomArrayItem = (array: string[]) => {
  if (array.length === 0) {
    throw new Error("Cannot get random item from empty array");
  }
  return array[Math.floor(Math.random() * array.length)]!;
};

export const generateRandomColor = (): string => {
  return getRandomArrayItem(USER_COLORS) ?? "#9ae6b4";
};
